<template>
	<div v-bind:class="classListRow" class="tc-schedule-list-row" v-on:click.stop="toggleExpand">
		<div class="tc-schedule-list-row-item" v-bind:class="classListRowItemBorder">
			<div class="tc-schedule-list-row-item-inner" v-bind:style="styleInner">
				<div class="tc-schedule-list-row-item-content d-flex">
					<v-icon class="icon-subdirectory" v-if="isChild">subdirectory_arrow_right</v-icon>
					<div style="width: 0%;">
						<div class="name">{{ item.name }}</div>
						<template v-if="item.isMember">
							<Classes
								:items="item.classes"
								:max_width="classesWidth()"
								:all_show=false
								class="list-classes"
								:is_show_icon=true
							/>
							<div class="list-info">
								<v-icon class="icon-message blue--text mr-1">message</v-icon>
								<template v-if="item.comment">
									{{ item.comment }}
								</template>
							</div>
						</template>
						<template v-if="item.isProject">
							<Classes
								:items="item.classes"
								:max_width="classesWidth()"
								:all_show=false
								class="list-classes"
								:is_show_icon=true
							/>
							<div class="list-info">{{ scheduleText() }}</div>
						</template>
						<template v-if="item.isTask">
							<div class="list-info mt-1 blue--text">{{ relatedName }}</div>
							<div class="list-info">{{ scheduleText() }}</div>
						</template>
					</div>
				</div>
				<div class="tc-schedule-list-row-item-action d-flex">
					<v-btn fab flat class="btn-slide"
						v-on:click.stop="toggleSlideLeft"
					><v-icon>more_horiz</v-icon></v-btn>
				</div>
				<div class="tc-schedule-list-row-item-right d-flex">
					<template v-if="isEditable">
						<v-btn depressed color="info" class="btn-add" v-if="!isChild" v-on:click.stop="onAddTask">タスク<br>追加</v-btn>
						<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowRightPane">編集</v-btn>
						<v-btn depressed color="error" class="btn-del" v-if="isChild" v-on:click.stop="onDeleteTask">削除</v-btn>
					</template>
					<template v-else>
						<v-btn depressed color="info" class="btn-show" v-on:click.stop="onShowRightPane">参照</v-btn>
					</template>
				</div>
			</div><!-- tc-schedule-list-row-item-inner -->
		</div>
	</div>
</template>
<script>
import { SLIDE } from '../../classes/Const';
import Classes from '../Classes';
import clonedeep from 'lodash/cloneDeep';
const uuidv4 = require('uuid/v4');
export default {
	name: 'TCScheduleListRow',
	props: [
		"item",
		"parent",
		"watchSlide",
	],
	components: {
		Classes,
	},
	data: function() {
		return {
			slide_status: SLIDE.STATUS.CENTER,
		};
	},
	methods: {
		toggleExpand: function() {
			this.toggleSlide(SLIDE.STATUS.CENTER);
			if (this.isChild)
				return;
			if (this.item.children.length === 0)
				return;
			this.$store.dispatch('chart/toggleExpand', this.item.code);
		},
		toggleSlide: function(direction) {
			if (this.slide_status === direction)
				this.slide_status = SLIDE.STATUS.CENTER;
			else {
				this.slide_status = direction;
				this.$emit('schedule-list-row-slide', {target: this.item, status: this.slide_status});
			}
		},
		toggleSlideLeft: function() {
			this.toggleSlide(SLIDE.STATUS.LEFT);
		},
		classesWidth: function() {
			let width = 244 - 11;

			if (this.isChild)
				width -= 14;

			return width;
		},
		scheduleText: function() {
			let length = this.item.schedules.length;
			if (length === 0)
				return "予定が入っておりません";
			
			let schedule = this.item.schedules[0];
			let text = "";
			if (schedule.all_day) {
				text = schedule.begin.strftimeDCL('%m月%d日') + "～" + schedule.end.strftimeDCL('%m月%d日')
			} else {
				if (schedule.isSingleDay) {
					text = schedule.begin.strftimeDCL('%m月%d日 %H:%M') + "～" + schedule.end.strftimeDCL('%H:%M')
				} else {
					text = schedule.begin.strftimeDCL('%m月%d日 %H:%M') + "～" + schedule.end.strftimeDCL('%H:%M %m月%d日')
				}
			}
			if (length > 1) {
				text += " 他" + String(length -1) + "件"
			}
			return text;
		},
		onShowRightPane: function() {
			if(this.item.isTask) {
				let task = this.$store.getters.task(this.item.code);
				this.$emit("show-task-info", task);
			} else if (this.item.isMember) {
				let member = this.$store.getters.member(this.item.code);
				this.$emit("show-member-info", member);
			} else if (this.item.isProject) {
				let project = this.$store.getters.project(this.item.code);
				this.$emit("show-project-info", project);
			}
			this.toggleSlideLeft();
		},
		onAddTask: function() {
			let task_code = uuidv4();
			if (this.item.isMember) {
				this.$store.dispatch('addTask', {
					task_code: task_code,
					member_code: this.item.code,
				}).then(() => {
					let task = this.$store.getters.task(task_code);
					if (task)
						this.$emit("add-task-info", task);
				});
			} else if (this.item.isProject) {
				let schedules = clonedeep(this.item.schedules);
				schedules.forEach( s => {
					s.code = uuidv4();
					s.task_code = task_code;
					s.project_code = this.item.code;
					s.member_code = '';
				});
				this.$store.dispatch('addTask', {
					task_code: task_code,
					project_code: this.item.code,
					schedules: schedules,
				}).then(() => {
					let task = this.$store.getters.task(task_code);
					if (task)
						this.$emit("add-task-info", task);
				});
			}
			this.toggleSlideLeft();
		},
		onDeleteTask: function() {
			if(!this.item.isTask) {
				return;
			}
			this.$emit("delete-task", this.item.code);
		},
	},
	computed: {
		isEditable: function() {
			return this.$store.getters['chart/isEditable'];
		},
		relatedName: function() {
			let text = "";
			if (this.$store.getters['chart/isDisplayMemberList']) {
				let project = this.$store.getters.project(this.item.project_code);
				if (project)
					text += "@" + project.name;
			} else {
				let member = this.$store.getters.member(this.item.member_code);
				if (member)
					text += member.name;
			}
			return text;
		},
		classListRow: function() {
			let classes = new Array();

			if (!this.isChild) {
				if (this.item.children.length > 0) {
					classes.push('parent-have-children');
				} else {
					classes.push('parent-not-have-children');
				}
			} else {
				classes.push('child');
			}

			return classes;
		},
		classListRowItemBorder: function() {
			if (this.isChild)
				return 'tc-schedule-list-row-item-border';
			return '';
		},
		styleInner: function() {
			let left = 0;
			if (this.slide_status == SLIDE.STATUS.LEFT) {
				left -= 60;
				if (this.isEditable)
					left -= 60;
			}

			return {
				left: left + 'px',
				transition: 'all .3s ease-in',
			};
		},
		isChild: function() {
			return this.parent !== undefined;
		},
	},
	watch: {
		isEditable: function() {
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		item: function() {
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		watchSlide: function() {
			if (this.watchSlide.type === 'slide' && this.watchSlide.target === this.item)
				return;
			if (this.slide_status !== SLIDE.STATUS.CENTER)
				this.slide_status = SLIDE.STATUS.CENTER;
		},
	},
};
</script>
<style>
	.tc-schedule-list-row.parent-have-children {
		background-color: #fefefe;
	}
	.tc-schedule-list-row.parent-not-have-children {
		background-color: #dcdcdc;
	}
	.tc-schedule-list-row.child {
		background-color: #f5f5f5;
	}
	.tc-schedule-list-row-item {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 299px;
		height: 49px;
	}
	.tc-schedule-list-row-item-border {
		border-top: 1px solid #ffffff;
	}
	.tc-schedule-list-row-item-inner {
		display: flex;
		position: absolute;
		width: 420px;
	}
	.tc-schedule-list-row-item-content {
		height: 49px;
		padding: .1em;
		width: 244px;
		padding-left: 0.5em;
	}
	.tc-schedule-list-row-item-content .name {
		font-size: 13px;
		height: 16px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.tc-schedule-list-row-item-content .list-classes {
		height: 1.2em;
	}
	.tc-schedule-list-row-item-content .list-info {
		font-size: 10px;
		height: 1.2em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.icon-subdirectory {
		font-size: 1em;
		align-items: baseline;
		flex: 0 0 auto !important;
	}
	.icon-message {
		font-size: 1em;
		align-items: baseline;
		flex: 0 0 auto !important;
	}

	.tc-schedule-list-row-item-action {
		position: relative;
	}

	.tc-schedule-list-row-item-action .btn-slide {
		min-width: 36px !important;
	}
</style>
<style scoped>
	.v-btn {
		margin: 0;
		padding: 0;
		min-width: 60px;
		height: 100%;
		border-radius: 0;
		font-size: .75em;
	}
</style>
